import { isLocal } from "../ConstruktedApi";

export default function getCursorStyle(centerX = 12, centerY = 12) {
    let imageUrl;

    if (!isLocal()) {
        imageUrl = `/wp-content/themes/gowatch-child/images/gcp.svg`;
    } else {
        imageUrl = `/gw4.construkted.com/wp-content/themes/gowatch-child/images/gcp.svg`;
    }

    return `url('${imageUrl}') ${centerX} ${centerY}, auto`;
}
